import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store/store";

import App from './App';
import './index.scss';
import './styles/alerts-style.scss'
import './styles/fields-style.scss'
import './i18n';
import applyIosViewportZoomFix from './utils/iosViewportZoomFix';

applyIosViewportZoomFix();




const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);
